import React from 'react'
import styled from 'styled-components'
import { media } from '../theme'

const Base = styled.span`
  display: ${(p) => (p.hide ? 'none' : 'block')};
  font-family: ${(p) => p.theme.fontFamily.primary};
  line-height: 100%;
  margin-bottom: ${(p) => (p.last ? 0 : p.theme.spacing(-1))};
  text-align: ${(p) => p.textAlign};
  text-transform: ${(p) => (p.em ? 'uppercase' : 'none')};
  margin-top: ${(p) => p.marginTop || undefined};

  ${media.greaterThan('medium')`
    max-width: ${(p) => (p.fullWidth ? '100%' : '88%')};
  `} em {
    color: #ffd98f;
  }
`

const Level1 = Base.withComponent('h2').extend`
color: #ffd98f;
font-size: ${(p) => p.theme.fontSize(p.large ? 3 : 2.5)};

${media.greaterThan('medium')`
font-size: ${(p) => p.theme.fontSize(p.large ? 4 : 3.5)};
`}
`

const Level2 = Level1.withComponent('h3').extend`
color: #fff;
`

const Level3 = Base.withComponent('h4').extend`
color: #c9e9ea;
font-size: ${(p) => p.theme.fontSize(p.large ? 2 : 1.5)};
`

const Level4 = Base.withComponent('h4').extend`
color: #76cdd9;
font-size: ${(p) => p.theme.fontSize(p.large ? 2 : 1)};
`
const Level5 = Base.withComponent('h2').extend`
  color: #fff;
  font-size: ${(p) => p.theme.fontSize(p.large ? 4 : 2.5)};

  ${media.greaterThan('medium')`
    font-size: ${(p) => p.theme.fontSize(p.large ? 5 : 3.5)};
  `}
`

const comps = [Level1, Level2, Level3, Level4, Level5]

const Heading = ({
  children,
  level = 1,
  last = false,
  large = false,
  em = true,
  fullWidth = false,
  textAlign = 'center',
  hide = false,
  ...props
}) => {
  const Comp = comps[level - 1]

  return (
    <Comp
      last={last}
      large={large}
      em={em}
      fullWidth={fullWidth}
      textAlign={textAlign}
      hide={hide}
      {...props}
    >
      {children}
    </Comp>
  )
}

export default Heading



// WEBPACK FOOTER //
// ./src/components/Heading.js